<template>
<div class="process_boxss wow fadeInUp"> 
  <el-row>
  <el-col :span="2" class="header_block"></el-col>
  <el-col :span="20" >
       <ul class="clearfix">
                        <li> <img :src="require('@/assets/imgs/service33.png')" alt="爱奇艺"> </li>
                        
                        <li> <img :src="require('@/assets/imgs/service31.png')" alt="腾讯"> </li>
                        <li> <img :src="require('@/assets/imgs/service36.png')" alt="酷狗音乐"> </li>
                        <li> <img :src="require('@/assets/imgs/service30.png')" alt="alibaba"> </li>
                         <li> <img :src="require('@/assets/imgs/service35.png')" alt="土豆"> </li>
                        
                        
                        <li> <img :src="require('@/assets/imgs/service34.png')" alt="bilibili"> </li>
                        <li> <img :src="require('@/assets/imgs/service32.png')" alt="京东"> </li>
                       
                        
                    </ul>
  </el-col>
  <el-col :span="2" class="header_block"></el-col>
</el-row>
                    
                </div>

</template>

<script>
// import titleBlock from '@/components/titleBlock.vue'

export default {
  name: 'serviceClient',
//   components: {
//     titleBlock
//   },
  // props: {
  //   videoArray: {
  //     type: Array,
  //     default: () => {
  //       return []
  //     },
  //   }
  // },
  data() {
    return {
      // serviceArray:[
      //   {url:require('@/assets/imgs/a01.png'),title:'商业视频',titleEng:'Commercial video'},
      //   {url:require('@/assets/imgs/a02.png'),title:'短视频',titleEng:'short video'},
      //   {url:require('@/assets/imgs/a01.png'),title:'视频课程',titleEng:'video course'},
      //   {url:require('@/assets/imgs/a03.png'),title:'多媒体展示',titleEng:'multimedia show'},
      // ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },

  // mounted(){
  // 　　window.addEventListener('scroll',this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  // },
  // methods:{
  //   handleScroll(){
  //     this.$nextTick(()=>{
	// 	let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  //    if (scrollTop > 60) {
  //      this.logoIndex = 1
  //      this.classNames = "nav_bg_white_add"
  //      this.menuClassNames = "menu_each each_toggle"
  //       } else {
  //      this.logoIndex = 0
  //      this.classNames = "nav_bg_white_reduce"
  //      this.menuClassNames = "menu_each "
  //       }
	// })
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.process_boxss{
  li{
    width: calc((100% - 70px) * 0.14285);
    margin-right: 10px;
    float: left;
    margin-bottom: 20px;
    img{
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
  li:nth-child(7n){
    margin-right: 0;
  }
  background: #F7F8FA;
  .header_block{
    min-height: 10px;
  }
  padding: 0 1%;
  // background: #fff;
  overflow:auto;
  // li{
  //     float: left;
  //   margin-bottom: 40px;
  //   width: 14%;
  //   img{
  //       width: 100%;
  //   }
  // }
}
</style>



